import req from '../req'
// 导出列表

// 获取配置详情
export function getFilesList (params) {
  return req.get('/files/download-filelist', params)
}
